<template>
    <div id="cyclic-definition_create">
        <v-container>
            <v-form
                    lazy-validation
                    ref="form"
            >
                <v-text-field
                        :rules="nameRules"
                        label="Name"
                        required
                        v-model="form.name"
                ></v-text-field>

                <v-select
                        :items="cyclicDefinitions"
                        :label="`${$t('cyclic.definition')}`"
                        :rules="cyclicDefinitionsRule"
                        item-text="name"
                        item-value="id"
                        required
                        v-model="form.cyclic_definition_id"
                >
                </v-select>

                <v-menu
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="form.from"
                        full-width
                        lazy
                        max-width="290px"
                        min-width="290px"
                        offset-y
                        ref="menuFrom"
                        transition="scale-transition"
                        v-model="menuFrom"
                >
                    <v-text-field
                            :label="`${$t('cycle.from')}`"
                            prepend-icon="event"
                            readonly
                            slot="activator"
                            v-model="form.from"
                    ></v-text-field>
                    <v-date-picker
                            no-title
                            scrollable
                            v-model="form.from"
                    >
                        <v-spacer></v-spacer>
                        <v-btn @click="menuFrom = false" color="primary" flat>{{$t('base.cancel')}}</v-btn>
                        <v-btn @click="$refs.menuFrom.save(form.from)" color="primary" flat>{{$t('base.ok')}}</v-btn>
                    </v-date-picker>
                </v-menu>

                <v-menu
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="form.to"
                        full-width
                        lazy
                        max-width="290px"
                        min-width="290px"
                        offset-y
                        ref="menuTo"
                        transition="scale-transition"
                        v-model="menuTo"
                >
                    <v-text-field
                            :label="`${$t('cycle.to')}`"
                            prepend-icon="event"
                            readonly
                            slot="activator"
                            v-model="form.to"
                    ></v-text-field>
                    <v-date-picker
                            no-title
                            scrollable
                            v-model="form.to"
                    >
                        <v-spacer></v-spacer>
                        <v-btn @click="menuTo = false" color="primary" flat>{{$t('base.cancel')}}</v-btn>
                        <v-btn @click="$refs.menuTo.save(form.to)" color="primary" flat>{{$t('base.ok')}}</v-btn>
                    </v-date-picker>
                </v-menu>

                <v-select
                        :items="lazy"
                        :label="`${$t('cycle.once')}`"
                        :rules="lazyRule"
                        item-text="name"
                        item-value="value"
                        required
                        v-model="form.lazy"
                >
                </v-select>


                <v-btn
                        @click="submit"
                        color="primary"
                >
                    {{$t('cyclic.confirm')}}
                </v-btn>
            </v-form>
        </v-container>
    </div>
</template>

<script>
import http from '@/plugins/http'

export default {
  components: {},
  data() {
    return {
      menuFrom: false,
      menuTo: false,
      nameRules: [
        v => !!v || this.$t('cycle.rules.once_required'),
        v => (v && v.length > 3) || this.$t('validator.minLength', {"minLength": 4}),
      ],
      lazyRule: [v => (v == 0 || v == 1) || this.$t('cycle.rules.once_required')],
      cyclicDefinitionsRule: [v => !!v],
      form: {},
      cyclicDefinitions: [],
    }
  },
  computed: {
    lazy() {
      return [{"name": this.$t('yes'), "value": 1}, {"name": this.$t('no'), "value": 0}]
    }

  },
  created() {
    this.loadCyclicDefinitions()
  },
  methods: {
    loadCyclicDefinitions() {
      this.loading = true
      http.get('cyclics')
          .then(({data}) => {
            this.cyclicDefinitions = data
          })
      this.loading = false
    },
    submit() {
      if (this.$refs.form.validate()) {
        let postData = {
          "name": this.form.name,
          "to": this.form.to,
          "cyclic_definition_id": this.form.cyclic_definition_id,
          "from": this.form.from,
          "lazy": this.form.lazy
        }
        http.post('cycle/create', postData)
            .then(() => {
              this.$router.push({"path": "/cycle/list"})
            })
      }
    }
  },
}
</script>

<style>

</style>
